import { AppliedFilters, CategoryFilters, CategorySort, GridSelector } from "@repo/components";
const ToolBar = ({
  sortOptions,
  selectedSort,
  appliedFilters,
  facets,
  initialColumns,
  isLineItemsExist
}) => {
  const isEmpty = appliedFilters && Object.keys(appliedFilters).length === 0;
  const appliedFilterCount = appliedFilters && Object.values(appliedFilters).reduce((sum, arr) => sum + arr.length, 0);
  return <>
      <div className="flex pb-4">
        <div className="me-auto flex items-center space-x-3 rtl:space-x-reverse">
          <CategoryFilters facets={facets} isEmpty={isEmpty} appliedFilterCount={appliedFilterCount} data-sentry-element="CategoryFilters" data-sentry-source-file="ToolBar.jsx" />
        </div>
        {isLineItemsExist && <div className="flex items-center space-x-4 rtl:space-x-reverse">
            <GridSelector initialColumns={initialColumns} />
            <CategorySort sortOptions={sortOptions} selectedSort={selectedSort} />
          </div>}
      </div>
      {!isEmpty && <div className="mb-4">
          <AppliedFilters appliedFilters={appliedFilters} appliedFilterCount={appliedFilterCount} />
        </div>}
    </>;
};
export default ToolBar;